import { createContext } from "react";

const defaultValue = {
  header: {},
  footer: {},
};

export const MenusContext = createContext(defaultValue);
